module.exports = "../static/media/logo_shadow.0782df0e.png";